<template>
   <div class="statistic">
      <Graph/>
      <div class="statistic--users">
        <Users/>
      </div>
      <Footy/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Graph from '@/components/Graph';
import Footy from '@/layouts/Footer';
import Users from '@/layouts/Users';

export default {
  name: 'statistic',
  components: {
    Footy,
    Graph,
    Users,
  },
  computed: mapGetters({
    person: 'personCurrent',
  }),
  mounted() {
    let userId = this.person.id;
    if (this.$route.params.user) {
      userId = this.$route.params.user;
    }
    this.$store.dispatch('fetchPerson', userId);
  },

};
</script>

<style>
@keyframes showStat{
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
.statistic{
  animation: showStat .8s ease-in-out;
  position: absolute;
  min-height: 790px;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;

  &--users{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
  }

  @media (min-height: 700px) {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// Stat.vue?6d63352c